import React from "react";
import "./Loader.css";

const Loader = ({ width, style }) => {
  const loaderStyle = {
    ...style,
    width: width || "50px",
    height: width || "50px"
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "90%",
    width: "100%"
  };
  return (
    <div style={containerStyle}>
      <div style={loaderStyle} className="builder_loader"></div>
    </div>
  );
};

export default Loader;
